import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import AccreditedInvestorProfileIndexItem from 'buyside/components/presentation/AccreditedInvestorIndexPage/AccreditedInvestorProfileIndexItem/accreditedInvestorProfileIndexItem';
import AccreditedInvestorProfileFilters from 'buyside/components/presentation/AccreditedInvestorIndexPage/accreditedInvestorProfileFilters';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import IndexPageHeader from 'buyside/components/presentation/IndexPageHeader/indexPageHeader';
import IndexPageListArea from 'buyside/components/presentation/IndexPageListArea/indexPageListArea';
import IndexPaginationNav from 'buyside/components/presentation/IndexPaginationNav/indexPaginationNav';

import { BREAKPOINTS, useIsMobile } from 'buyside/util/hooks/useIsMobile';
import { validatePageParam } from 'buyside/util/numbers';
import { inviteMembersUrl } from 'buyside/util/urlHelper';
const { indexTypes } = require('buyside/util/constantsFromRails.json');

import { useAccreditedInvestorProfilesIndexListQuery } from 'interfaces/graphql-typings';

import styles from './accreditedInvestorIndexPageStyles.scss';

const AccreditedInvestorIndexPage: React.FC = () => {
  const isMobile = useIsMobile(BREAKPOINTS.LARGE);

  const [searchParams] = useSearchParams();
  validatePageParam(searchParams);
  const indexType = indexTypes.accredited_investor;

  const { data, loading, error, previousData } = useAccreditedInvestorProfilesIndexListQuery({
    variables: {
      indexType,
      searchParams: searchParams.toString()
    }
  });

  if (error) throw error;

  const accreditedInvestorProfilesIndexList = (data || previousData)
    ?.accreditedInvestorProfilesIndexList;
  const currentUser = (data || previousData)?.currentUser;
  const indexListResultCount = (data || previousData)?.indexListResultCount || 0;

  const renderFilters = useCallback(() => <AccreditedInvestorProfileFilters />, []);
  const renderSideButtons = useCallback(
    () => (
      <Button
        type={BUTTON_TYPES.PRIMARY}
        size={BUTTON_SIZES.SMALL}
        text="Invite New Members"
        url={inviteMembersUrl()}
      />
    ),
    []
  );

  return (
    <main className={styles.main}>
      <div className={styles.indexPageContainer}>
        <div className={styles.mainIndexPageArea}>
          <IndexPageHeader
            header="Accredited Investors"
            renderFilters={renderFilters}
            renderSideButtons={renderSideButtons}
            resultCount={indexListResultCount}
          />
          <IndexPageListArea
            card={AccreditedInvestorProfileIndexItem}
            currentUser={currentUser}
            data={accreditedInvestorProfilesIndexList}
            isMobile={isMobile}
            loading={loading}
          />
          <IndexPaginationNav
            loading={loading}
            resultCount={indexListResultCount}
            resultLength={
              accreditedInvestorProfilesIndexList ? accreditedInvestorProfilesIndexList.length : 0
            }
            resultsPerPage={20}
          />
        </div>
      </div>
    </main>
  );
};

export default AccreditedInvestorIndexPage;
